import React from 'react';

interface Props {
  identifier: string;
  callback: Function;
}
export const handleDOMClickHOC = (identifier, callback) => event => {
  if (identifier.includes(',') && identifier.split(',').length > 1) {
    let flag = false;
    identifier.split(',').map(i => {
      const elem = document.querySelector(i);
      if (elem && elem.contains(event.target) && flag === false) {
        flag = true;
      }
    });

    if (!flag) {
      callback(false);
    }
  } else {
    const elem = document.querySelector(identifier);
    if (elem && !elem.contains(event.target)) callback(false);
  }
};

const ClickOutside = (props: React.PropsWithChildren<Props>) => {
  const { callback, identifier } = props;

  React.useEffect(() => {
    const listener = handleDOMClickHOC(identifier, callback);
    document.addEventListener('click', listener);
    return () => document.removeEventListener('click', listener);
  }, []);

  return <>{props.children}</>;
};

export default ClickOutside;
